/**
 * Standardized size constants for SPDS components.
 *
 * These constants provide a consistent vocabulary for component sizing
 * across the design system. While components may use the same size values,
 * the visual meaning is component-specific (e.g., 'small' button vs 'small' card).
 */

// Individual size tokens
export const LARGE = 'large';
export const MEDIUM = 'medium';
export const NORMAL = 'normal';
export const SMALL = 'small';

// Component-specific size arrays
export const BADGE_SIZES = Object.freeze([NORMAL, SMALL]);
export const BUTTON_SIZES = Object.freeze([NORMAL, SMALL]);
export const CARD_SIZES = Object.freeze([LARGE, MEDIUM, SMALL]);
export const FLYOUT_SIZES = Object.freeze([SMALL, LARGE]);

export default {
  // Individual tokens
  LARGE,
  MEDIUM,
  NORMAL,
  SMALL,
  // Component arrays
  BADGE_SIZES,
  BUTTON_SIZES,
  CARD_SIZES,
  FLYOUT_SIZES,
};
